import { useLocation, Link } from "@/lib/router-compat";
import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center max-w-md px-4">
        <h1 className="mb-4 text-6xl font-heading font-bold text-foreground">404</h1>
        <p className="mb-6 text-xl text-muted-foreground">Sorry, we couldn't find that page.</p>
        <Link to="/">
          <Button className="bg-secondary hover:bg-secondary/90 text-secondary-foreground font-semibold">
            Back to Home <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
